<div class="header header-checkout container">
  <!-- <div class="header-utility col-3 col-md-12">
    <ul class="user-links">
      <li><ish-login-status [logoutOnly]="true" /></li>
    </ul>
  </div> -->
  <div class="mid-header col-12 col-md-12">
    <div class="logo-wrapper d-md-none">
      <a
        rel="home"
        routerLink="/home"
        class="mobile-logo"
        [attr.aria-label]="'common.home.link' | translate"
        data-testing-id="link-home"
      ></a>
    </div>
    <div class="logo-wrapper d-none d-md-block">
      <a
        rel="home"
        routerLink="/home"
        class="logo"
        [attr.aria-label]="'common.home.link' | translate"
        data-testing-id="header-home-link-desktop"
      ></a>
    </div>
  </div>
</div>
